const C = (i) => {
  let t = i?.canvas?.parentNode?.querySelector("div");
  if (!t) {
    t = document.createElement("div"), t.id = "chart-tooltip", t.style.background = "white", t.style.color = "black", t.style.opacity = "1", t.style.background = "transparent", t.style.position = "absolute", t.style.transform = "translate(-50%, 0)", t.style.transition = "all .1s ease", t.style.zIndex = "2";
    const e = document.createElement("div");
    e.style.width = "24px", e.style.height = "24px", e.style.position = "absolute", e.style.left = "98px", e.style.bottom = "-10px", e.style.background = "#fff", e.style.transform = "rotate(45deg)", e.style.borderStyle = "solid", e.style.borderBottomWidth = "4px", e.style.borderRightWidth = "4px", e.style.borderTopWidth = "0", e.style.borderLeftWidth = "0", e.style.borderColor = "inherit", e.style.zIndex = "2", t.appendChild(e);
    const o = document.createElement("div"), l = document.createElement("table");
    l.style.margin = "0", l.style.width = "220px", l.style.position = "relative", l.style.backgroundColor = "#fff", o.style.backgroundColor = "#FFF", o.style.borderWidth = "4px", o.style.borderStyle = "solid", o.style.borderColor = "inherit", l.style.zIndex = "3", o.appendChild(l), t.appendChild(o), i?.canvas?.parentNode?.appendChild(t);
  }
  return t;
}, g = (i) => (t) => {
  const { chart: e, tooltip: o } = t, l = o, r = C(e);
  if (o.opacity === 0) {
    r.style.opacity = "0";
    return;
  }
  if (o.body) {
    const y = o.title || [], u = o.body.map((s) => s.lines), h = document.createElement("thead");
    y.forEach((s) => {
      const a = document.createElement("tr");
      a.style.borderWidth = "0";
      const d = document.createElement("th");
      d.style.borderWidth = "0", d.style.padding = "4px 8px", d.style.margin = "4px 0", d.style.textAlign = "left";
      const n = document.createTextNode(s);
      d.appendChild(n), a.appendChild(d), h.appendChild(a);
    });
    const m = document.createElement("tbody");
    u.forEach((s, a) => {
      const d = l._active[a];
      r.style.borderColor = String(i(d.datasetIndex));
      const n = document.createElement("tr");
      n.style.backgroundColor = "inherit", n.style.borderWidth = "0";
      const p = document.createElement("td");
      p.style.borderWidth = "0", p.style.padding = "0 8px 8px 8px";
      const x = document.createTextNode(s.join(""));
      p.appendChild(x), n.appendChild(p), m.appendChild(n);
    });
    const c = r.querySelector("table");
    for (; c?.firstChild; )
      c.firstChild.remove();
    c?.appendChild(h), c?.appendChild(m);
  }
  const { offsetLeft: b, offsetTop: f } = e.canvas;
  if (r) {
    r.style.opacity = "1";
    const y = r.getBoundingClientRect();
    r.style.left = b + o.caretX + "px", r.style.top = f + o.caretY - y.height - 16 + "px";
  }
};
export {
  g as createExternalTooltipHandler,
  C as getOrCreateTooltip
};
//# sourceMappingURL=index.es363.js.map
